import { Component } from '@angular/core';

@Component({
    selector: 'igx-grid-footer',
    template: '<ng-content></ng-content>'
})
export class IgxGridFooterComponent {
}
